import { render } from "./LayoutDefault.vue?vue&type=template&id=70fe6cb6&scoped=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"

import "./LayoutDefault.vue?vue&type=style&index=0&id=70fe6cb6&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fe6cb6"]])

export default __exports__